/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pre-op-assessment.reducer';

export const PreOpAssessmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const preOpAssessmentEntity = useAppSelector(state => state.preOpAssessment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="preOpAssessmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.preOpAssessment.detail.title">PreOpAssessment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.id">Id</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.id}</dd>
          <dt>
            <span id="surgeryDateTime">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.surgeryDateTime">Surgery Date Time</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.surgeryDateTime}</dd>
          <dt>
            <span id="hypertension">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.hypertension">Hypertension</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.hypertension ? 'true' : 'false'}</dd>
          <dt>
            <span id="diabetes">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.diabetes">Diabetes</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.diabetes ? 'true' : 'false'}</dd>
          <dt>
            <span id="asthma">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.asthma">Asthma</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.asthma ? 'true' : 'false'}</dd>
          <dt>
            <span id="allergy">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.allergy">Allergy</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.allergy ? 'true' : 'false'}</dd>
          <dt>
            <span id="epilepsy">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.epilepsy">Epilepsy</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.epilepsy ? 'true' : 'false'}</dd>
          <dt>
            <span id="ihd">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.ihd">Ihd</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.ihd ? 'true' : 'false'}</dd>
          <dt>
            <span id="thyroid">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.thyroid">Thyroid</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.thyroid}</dd>
          <dt>
            <span id="previousSurgeyInfo">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.previousSurgeyInfo">Previous Surgey Info</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.previousSurgeyInfo}</dd>
          <dt>
            <span id="historyOfTB">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.historyOfTB">History Of TB</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.historyOfTB}</dd>
          <dt>
            <span id="otherHistory">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.otherHistory">Other History</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.otherHistory}</dd>
          <dt>
            <span id="icterus">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.icterus">Icterus</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.icterus ? 'true' : 'false'}</dd>
          <dt>
            <span id="pallor">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.pallor">Pallor</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.pallor ? 'true' : 'false'}</dd>
          <dt>
            <span id="lymphadenopathy">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.lymphadenopathy">Lymphadenopathy</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.lymphadenopathy}</dd>
          <dt>
            <span id="edema">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.edema">Edema</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.edema ? 'true' : 'false'}</dd>
          <dt>
            <span id="airwayDentition">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.airwayDentition">Airway Dentition</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.airwayDentition}</dd>
          <dt>
            <span id="thyroidText">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.thyroidText">Thyroid Text</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.thyroidText}</dd>
          <dt>
            <span id="spine">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.spine">Spine</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.spine}</dd>
          <dt>
            <span id="mallampatiGrade">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.mallampatiGrade">Mallampati Grade</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.mallampatiGrade}</dd>
          <dt>
            <span id="tmDistance">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.tmDistance">Tm Distance</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.tmDistance}</dd>
          <dt>
            <span id="cvs">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.cvs">Cvs</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.cvs}</dd>
          <dt>
            <span id="respiratorySystem">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.respiratorySystem">Respiratory System</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.respiratorySystem}</dd>
          <dt>
            <span id="git">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.git">Git</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.git}</dd>
          <dt>
            <span id="cns">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.cns">Cns</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.cns}</dd>
          <dt>
            <span id="otherFindings">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.otherFindings">Other Findings</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.otherFindings}</dd>
          <dt>
            <span id="psychologicalNeeds">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.psychologicalNeeds">Psychological Needs</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.psychologicalNeeds ? 'true' : 'false'}</dd>
          <dt>
            <span id="socialNeeds">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.socialNeeds">Social Needs</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.socialNeeds ? 'true' : 'false'}</dd>
          <dt>
            <span id="economicNeeds">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.economicNeeds">Economic Needs</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.economicNeeds ? 'true' : 'false'}</dd>
          <dt>
            <span id="otherInvestigations">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.otherInvestigations">Other Investigations</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.otherInvestigations}</dd>
          <dt>
            <span id="dischargeNeeds">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.dischargeNeeds">Discharge Needs</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.dischargeNeeds}</dd>
          <dt>
            <span id="ecg">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.ecg">Ecg</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.ecg}</dd>
          <dt>
            <span id="echo">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.echo">Echo</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.echo}</dd>
          <dt>
            <span id="chestXRay">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.chestXRay">Chest X Ray</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.chestXRay}</dd>
          <dt>
            <span id="typeOfAnaesthesia">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.typeOfAnaesthesia">Type Of Anaesthesia</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.typeOfAnaesthesia}</dd>
          <dt>
            <span id="aSaCategory">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.aSaCategory">A Sa Category</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.aSaCategory}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.active">Active</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.timestampentry}</dd>
          <dt>
            <span id="testsIgnored">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.testsIgnored">Tests Ignored</Translate>
            </span>
          </dt>
          <dd>{preOpAssessmentEntity.testsIgnored ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpAssessment.surgery">Surgery</Translate>
          </dt>
          <dd>{preOpAssessmentEntity.surgery ? preOpAssessmentEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpAssessment.anaesthesiologist">Anaesthesiologist</Translate>
          </dt>
          <dd>{preOpAssessmentEntity.anaesthesiologist ? preOpAssessmentEntity.anaesthesiologist.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpAssessment.vitals">Vitals</Translate>
          </dt>
          <dd>{preOpAssessmentEntity.vitals ? preOpAssessmentEntity.vitals.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpAssessment.labPres">Lab Pres</Translate>
          </dt>
          <dd>{preOpAssessmentEntity.labPres ? preOpAssessmentEntity.labPres.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pre-op-assessment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pre-op-assessment/${preOpAssessmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PreOpAssessmentDetail;
